import { RouterInfo } from '../interfaces/router-info';

// -----------------------------------------------------------------------------------------------------
// @ Constantes Rutas
// -----------------------------------------------------------------------------------------------------

/**
 * @constant
 * @desc Rutas Sidebar
 */
export const ROUTES: RouterInfo[] = [
  {
    path: '',
    title: 'APPLICATIONS',
    type: "sub",
    icontype: "gestures_tap-01",
    collapse: "Aplicaciones",
    isCollapsed: true,
    children: [
      {
        path: '',
        title: 'MULTIPLEX_DS_MOVIL',
        ab: 'AB-MULTIPLEX_DS_MOVIL',
        isDownloader: true,
        link: 'https://play.google.com/store/apps/details?id=com.multiplex.app'
      },
      {
        path: '',
        title: 'MULTIPLEX_SCANNER',
        ab: 'AB-MULTIPLEX_SCANNER',
        isDownloader: true,
        link: 'https://play.google.com/store/apps/details?id=com.multiplex.diagnostics.app'
      },
    ]
  },
  {
    path: '',
    title: 'DOWNLOADS',
    type: "sub",
    icontype: "arrows-1_cloud-download-93",
    collapse: "descargas",
    isCollapsed: true,
    children: [
      {
        path: '',
        title: 'USER_MANUAL',
        ab: 'AB-USER-MANUAL',
        isDownloader: true,
        link: 'v1.0.0/mds-user-manual.pdf'
      },
      {
        path: '',
        title: 'PLUGIN_GUIDE',
        ab: 'AB-PLUGIN-GUIDE',
        isDownloader: true,
        link: 'v1.0.0/guide-plugin-bluetooth.pdf'
      },
      {
        path: '',
        title: 'BLOCK_GUIDE',
        ab: 'AB-BLOCK-GUIDE',
        isDownloader: true,
        link: 'v1.0.0/mds-guide-blocks.pdf'
      },
      {
        path: '',
        title: 'PLUGIN',
        ab: 'AB-PLUGIN',
        isDownloader: true,
        link: 'v1.0.0/mowin-communication-plugin.zip'
      },
    ]
  },
  {
    path: '',
    title: 'PROJECTS',
    type: 'sub',
    icontype: 'files_paper',
    collapse: 'proyectos',
    isCollapsed: true,
    children: [
      {
        path: 'project-admin',
        title: 'PROJECT_ADMIN',
        ab: 'AB-PROJECT-ADMIN',
        isDownloader: false
      },
      {
        path: 'network-config',
        title: 'NETWORK_CONFIG',
        ab: 'AB-NETWORK-CONFIG',
        isDownloader: false
      },
      {
        path: 'devices-admin',
        title: 'DEVICES_ADMIN',
        ab: 'AB-DEVICES_ADMIN',
        isDownloader: false
      },
      {
        path: 'operation-logic',
        title: 'OPERATION_LOGIC',
        ab: 'AB-OPERATION_LOGIC',
        isDownloader: false
      },
    ]
  },
  //! {
  //!   path: '/custom-blocks',
  //!   title: 'CUSTOM_BLOCKS',
  //!   type: "link",
  //!   icontype: "design_app"
  //! },
  {
    path: '/transfer',
    title: 'TRANSFER',
    type: "link",
    icontype: "ui-1_send"
  },
];